import dayjs, { Dayjs } from "dayjs";
export const FORMAT_DATETIME = "YYYY-MM-DD HH:mm:ss";
export const FORMAT_DATE_MINUTE = "YYYY-MM-DD HH:mm";
export const FORMAT_DATE = "DD MMM YYYY";
export const DATE_WEEK: any = [dayjs().subtract(7, "day"), dayjs()];
export const DATE_YEAR: any = [dayjs().startOf("year"), dayjs().endOf("year")];
export const FORMAT_API_DATE = "YYYY-MM-DD";

export function isBefore(current: dayjs.ConfigType): boolean {
  const today = new Date().setHours(0, 0, 0, 0);
  return dayjs(current).isBefore(today);
}

export function confirmDayjs(date: dayjs.ConfigType) {
  let returnDayJs;

  if (!date) {
    return dayjs();
  }

  if (date instanceof Date) {
    returnDayJs = dayjs(date)
  } else {
    returnDayJs = date;
  }
  return returnDayJs as Dayjs;
}


export function formatDate(date: dayjs.ConfigType): string {
  return dayjs(date).format(FORMAT_DATE);
}

export function formatApiDate(date: dayjs.ConfigType): string {
  return dayjs(date).format(FORMAT_API_DATE);
}

export function formatDateTime(date: dayjs.ConfigType): string {
  return dayjs(date).format(FORMAT_DATETIME);
}

export function formatDateMinute(date: dayjs.ConfigType): string {
  return dayjs(date).format(FORMAT_DATE_MINUTE);
}

export function fromNow(startDate: dayjs.ConfigType, endDate: dayjs.ConfigType): number {
  const start = dayjs(startDate).valueOf();
  const end = dayjs(endDate || Date.now()).valueOf();
  const n = end - start;
  return Math.ceil(n / (1000 * 60 * 60 * 24));
}

export function isToDay(date: dayjs.ConfigType): boolean {
  const m = dayjs(date);
  const n = new Date();
  return m.year() === n.getFullYear() && m.month() === n.getMonth() && m.date() === n.getDate();
}

export function getLastWeeksDate() {
  const now = new Date();
  return dayjs(new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7)).format(
    FORMAT_API_DATE
  );
}

export function getTodayDate() {
  const now = new Date();
  return dayjs(new Date(now.getFullYear(), now.getMonth(), now.getDate())).format(FORMAT_API_DATE);
}

export function getLastMonthDate() {
  const today = new Date();
  return dayjs(new Date(today.getFullYear(), today.getMonth() - 1, today.getDate())).format(
    FORMAT_API_DATE
  );
}

export function getLastYearDate() {
  const today = new Date();
  return dayjs(new Date(today.getFullYear() - 1, today.getMonth(), today.getDate())).format(
    FORMAT_API_DATE
  );
}

export function isDate(value: any) {
  const dateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
  return dateRegex.test(value);
}

export function calculateDaysAgo(targetDate: Date) {
  const currentDate = new Date();
  const targetD = new Date(targetDate);

  const targetDateMs = targetD.getTime();
  const currentDateMs = currentDate.getTime();

  const differenceMs = currentDateMs - targetDateMs;

  const daysAgo = Math.floor(differenceMs / (1000 * 60 * 60 * 24));

  if (daysAgo <= 0) {
    return 1;
  }

  return daysAgo;
}